export default {
  app: {
    notFound: {
      title: 'Página não encontrada.',
      subtitle: 'Parece que você se perdeu.',
      text: 'Não se preocupe, nós o ajudaremos a navegar a partir daqui',
    },
  },
};
